var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrophe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 98,
    viewBox: "0 0 52 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3834 35.4673H24.6172V52.3122H27.3834V35.4673Z",
    fill: "#FFB10F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.424 54.2483H21.5723C21.5723 53.7348 21.7763 53.2423 22.1394 52.8791C22.5025 52.516 22.995 52.312 23.5086 52.312H28.4877C29.0013 52.312 29.4938 52.516 29.8569 52.8791C30.22 53.2423 30.424 53.7348 30.424 54.2483Z",
    fill: "#FFDC01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5851 90.0425H6.41602L8.62896 56.1646H43.5935L45.5851 90.0425Z",
    fill: "#893003"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5934 56.1646H8.62888L8.49609 58.1717C16.8123 61.3805 30.2272 68.11 35.3148 79.4669C37.3219 83.9503 38.7935 87.3981 39.8734 90.0425H45.585L43.5934 56.1646Z",
    fill: "#7A2B03"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0358 54.248H7.96484V56.1644H44.0358V54.248Z",
    fill: "#FFB10F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59067 90.043H47.4111C47.8807 90.043 48.331 90.2295 48.663 90.5615C48.995 90.8935 49.1815 91.3438 49.1815 91.8133V95.3916H2.82031V91.8133C2.82031 91.3438 3.00683 90.8935 3.33884 90.5615C3.67084 90.2295 4.12114 90.043 4.59067 90.043Z",
    fill: "#FFB10F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4094 90.043H39.8301C40.2996 90.043 40.7499 90.2295 41.0819 90.5615C41.4139 90.8935 41.6004 91.3438 41.6004 91.8133V95.3916H49.1798V91.8133C49.1798 91.3438 48.9932 90.8935 48.6612 90.5615C48.3292 90.2295 47.8789 90.043 47.4094 90.043Z",
    fill: "#FFA30F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5044 95.3516H0.496094V97.4539H51.5044V95.3516Z",
    fill: "#D67205"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5044 96.8008H0.496094V97.4514H51.5044V96.8008Z",
    fill: "#BD6504"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6172 39.3552L26.1928 38.6935L27.3834 39.1693V35.4692H24.6172V39.3552Z",
    fill: "#E09C0D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8307 41.776L26.1724 36.3011L12.607 42.0061L13.594 27.3232L3.97656 16.1877L18.2434 12.5894L25.8626 0L33.6964 12.4567L48.023 15.8137L38.5937 27.113L39.8307 41.776Z",
    fill: "#FFDC01"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7589 41.101C22.5042 32.5524 27.6161 18.7968 27.8773 3.20214L25.8635 0L18.2532 12.5894L3.98633 16.1877L13.606 27.3232L12.619 42.0061L14.7589 41.101Z",
    fill: "#FFDC01"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8239 32.5326L19.5547 23.7914C19.5316 23.7689 19.5138 23.7415 19.5024 23.7113C19.4911 23.6811 19.4865 23.6488 19.4889 23.6166C19.4914 23.5844 19.5008 23.5532 19.5166 23.525C19.5324 23.4969 19.5542 23.4725 19.5804 23.4537C19.6066 23.4349 19.6366 23.422 19.6683 23.416C19.7 23.41 19.7327 23.411 19.764 23.4189C19.7952 23.4268 19.8244 23.4415 19.8494 23.4619C19.8744 23.4823 19.8947 23.5079 19.9087 23.537L26.178 32.2781C26.2105 32.3254 26.2233 32.3834 26.2138 32.44C26.2043 32.4965 26.1732 32.5472 26.1271 32.5813C26.0801 32.6139 26.0222 32.6271 25.9657 32.6181C25.9092 32.609 25.8583 32.5783 25.8239 32.5326Z",
    fill: "#FFF8A4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3909 35.5996L18.4494 16.9887C18.4162 16.9422 18.4023 16.8847 18.4105 16.8282C18.4188 16.7717 18.4486 16.7206 18.4936 16.6855C18.54 16.6515 18.5978 16.6368 18.6548 16.6446C18.7118 16.6525 18.7635 16.6822 18.799 16.7276L32.7405 35.3384C32.7644 35.385 32.771 35.4385 32.7592 35.4894C32.7474 35.5403 32.718 35.5855 32.6761 35.6168C32.6342 35.648 32.5825 35.6635 32.5303 35.6603C32.4781 35.6572 32.4287 35.6357 32.3909 35.5996Z",
    fill: "#FFF8A4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8688 37.5382L22.6794 17.427C22.6563 17.4042 22.6385 17.3766 22.6271 17.3462C22.6158 17.3158 22.6114 17.2833 22.614 17.2509C22.6167 17.2186 22.6265 17.1872 22.6426 17.1591C22.6588 17.1309 22.6809 17.1067 22.7074 17.088C22.734 17.0694 22.7644 17.0568 22.7963 17.0512C22.8283 17.0456 22.8611 17.0471 22.8924 17.0555C22.9237 17.064 22.9528 17.0793 22.9776 17.1003C23.0023 17.1212 23.0222 17.1474 23.0357 17.1769L37.2163 37.2859C37.2487 37.3332 37.2615 37.3912 37.2521 37.4478C37.2426 37.5043 37.2115 37.555 37.1654 37.5891C37.1186 37.6196 37.0621 37.6312 37.0071 37.6218C36.9521 37.6123 36.9028 37.5825 36.8688 37.5382Z",
    fill: "#FFF8A4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9405 25.449L23.3142 11.7287C23.2911 11.706 23.2732 11.6784 23.2619 11.648C23.2506 11.6176 23.2461 11.585 23.2488 11.5527C23.2515 11.5203 23.2612 11.489 23.2774 11.4608C23.2935 11.4327 23.3156 11.4084 23.3422 11.3898C23.3688 11.3711 23.3991 11.3586 23.4311 11.3529C23.463 11.3473 23.4959 11.3488 23.5272 11.3573C23.5585 11.3658 23.5876 11.3811 23.6123 11.402C23.6371 11.423 23.657 11.4491 23.6705 11.4786L33.2968 25.1989C33.329 25.2464 33.3415 25.3047 33.3316 25.3612C33.3217 25.4178 33.2902 25.4683 33.2437 25.5021C33.1961 25.5343 33.1379 25.5468 33.0814 25.5369C33.0248 25.527 32.9743 25.4954 32.9405 25.449Z",
    fill: "#FFF8A4"
  })))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3847 18.3079L28.8993 13.1075C28.8785 13.0599 28.8752 13.0064 28.8899 12.9566C28.9046 12.9067 28.9364 12.8636 28.9797 12.8348C29.023 12.8061 29.075 12.7935 29.1266 12.7992C29.1783 12.805 29.2263 12.8287 29.2622 12.8663L32.7476 18.0667C32.7683 18.1144 32.7717 18.1678 32.757 18.2177C32.7423 18.2675 32.7105 18.3106 32.6672 18.3394C32.6239 18.3682 32.5719 18.3808 32.5202 18.3751C32.4685 18.3693 32.4206 18.3455 32.3847 18.3079Z",
    fill: "#FFF8A4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6091 74.5674H18.9014C18.9014 74.8608 18.7848 75.1423 18.5773 75.3498C18.3698 75.5573 18.0884 75.6739 17.7949 75.6739V83.7445C18.0884 83.7445 18.3698 83.861 18.5773 84.0685C18.7848 84.276 18.9014 84.5575 18.9014 84.8509H35.6091C35.6091 84.5575 35.7257 84.276 35.9332 84.0685C36.1407 83.861 36.4221 83.7445 36.7156 83.7445V75.6739C36.4221 75.6739 36.1407 75.5573 35.9332 75.3498C35.7257 75.1423 35.6091 74.8608 35.6091 74.5674Z",
    fill: "#FFCC00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9004 74.5674C18.9004 74.5962 18.9004 74.6249 18.9004 74.6537L26.9887 84.8509H28.1195L19.9626 74.5674H18.9004Z",
    fill: "#F9C569"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7949 75.6738V76.2271L24.6351 84.8575H25.1994L17.9166 75.6738C17.8761 75.6761 17.8355 75.6761 17.7949 75.6738Z",
    fill: "#F9C569"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0547 74.5674L30.2116 84.8509H30.7781L22.6212 74.5674H22.0547Z",
    fill: "#F9C569"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2227 74.5674L32.3773 84.8509H33.2249L25.0702 74.5674H24.2227Z",
    fill: "#F9C569"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3208 91.4895H33.2311C33.1724 91.4895 33.1161 91.4662 33.0746 91.4247C33.0331 91.3832 33.0098 91.3269 33.0098 91.2682C33.0098 91.2095 33.0331 91.1532 33.0746 91.1117C33.1161 91.0702 33.1724 91.0469 33.2311 91.0469H38.3208C38.3795 91.0469 38.4358 91.0702 38.4773 91.1117C38.5188 91.1532 38.5421 91.2095 38.5421 91.2682C38.5421 91.3269 38.5188 91.3832 38.4773 91.4247C38.4358 91.4662 38.3795 91.4895 38.3208 91.4895Z",
    fill: "#F9C569"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8934 91.4895H26.4166C26.3579 91.4895 26.3016 91.4662 26.2601 91.4247C26.2186 91.3832 26.1953 91.3269 26.1953 91.2682C26.1953 91.2095 26.2186 91.1532 26.2601 91.1117C26.3016 91.0702 26.3579 91.0469 26.4166 91.0469H30.8934C30.9521 91.0469 31.0084 91.0702 31.0499 91.1117C31.0914 91.1532 31.1147 91.2095 31.1147 91.2682C31.1147 91.3269 31.0914 91.3832 31.0499 91.4247C31.0084 91.4662 30.9521 91.4895 30.8934 91.4895Z",
    fill: "#F9C569"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2278 91.4895H4.90879C4.8501 91.4895 4.79382 91.4662 4.75232 91.4247C4.71082 91.3832 4.6875 91.3269 4.6875 91.2682C4.6875 91.2095 4.71082 91.1532 4.75232 91.1117C4.79382 91.0702 4.8501 91.0469 4.90879 91.0469H24.2278C24.2865 91.0469 24.3428 91.0702 24.3843 91.1117C24.4258 91.1532 24.4491 91.2095 24.4491 91.2682C24.4491 91.3269 24.4258 91.3832 24.3843 91.4247C24.3428 91.4662 24.2865 91.4895 24.2278 91.4895Z",
    fill: "#F9C569"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophe);
export default __webpack_public_path__ + "static/media/trophe.6dd4a25742fb483ebc7a10e95ea11877.svg";
export { ForwardRef as ReactComponent };